import React, { Component } from 'react'
import Style from './AddOrganization.module.css'
import { createCustomer, setError } from '../store/entities/customers'
import { setNewToken } from '../store/entities/user'
import { connect } from 'react-redux'
import jwt_decode from "jwt-decode";
import ModalPopup from '../components/common/ModalPopup';
import { CookieUtils } from '../utilities/cookies'
import BackIcon from '../assets/backButton.svg'
import { validateEmail, validateAlphaNumerics } from '../utilities/vaildations' 


class AddOrganization extends Component {

    constructor() {
        super();
        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            organizationName: '',
            noOfUsers: '',
            orgCode : ''
        };
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.customerFlag !== this.props.customerFlag) {
            if (this.props.customerFlag) {
                this.props.setNewToken()
            }
        }
    }
    
    handleChange = (event) => {
        const value = event.target.value
        this.setState({
            [event.target.name]: value
        })
    }

    handleClick = () => {
        this.props.history.push({ pathname: '/tenant-admin', state: { tab: 'Organization Management' } })
    }

    handleSubmit = () => {
        let error = ''

        // if(this.state.lastName === '') {
        //     error = "Last name is required"
        //     this.props.setError(error)
        // } else 
        if (this.state.lastName.length > 0 && !validateAlphaNumerics(this.state.lastName) || this.state.lastName.length > 50) {
            error = "Last name should only be alphanumeric and not more than 50 characters"
            this.props.setError(error)
        }

        // if(this.state.firstName === '') {
        //     error = "First name is required"
        //     this.props.setError(error)
        // } else 
        if (this.state.firstName.length > 0 && !validateAlphaNumerics(this.state.firstName) || this.state.firstName.length > 50) {
            error = "First name should only be alphanumeric and not more than 50 characters"
            this.props.setError(error)
        }

        // if(this.state.email === '') {
        //     error = "Email is required"
        //     this.props.setError(error)
        // } else 
        if (this.state.email.length > 0 && !validateEmail(this.state.email) || this.state.email.length > 200) {
            error = "Please enter a proper email id"
            this.props.setError(error)
        }

        if(this.state.organizationName === '') {
            error = "Organization name is required"
            this.props.setError(error)
        } else if (this.state.organizationName.length > 250) {
            error = "Organization name should not be more than 250 characters"
            this.props.setError(error)
        }

        if(this.state.noOfUsers === ''){
            error = "No. of Users is required"
            this.props.setError(error)
        }else if(this.state.noOfUsers.length != 0 &&  isNaN(this.state.noOfUsers)){
            error = "No. of Users should be a number"
            this.props.setError(error)
        }
        else if(this.state.noOfUsers > 5000000){
            error = "No. of Users should not be more than 5M"   
            this.props.setError(error)
        }

        if(this.state.orgCode && this.state.orgCode.length > 50){
            error = "Organization Code cannot be more than 50 characters"
            this.props.setError(error);
        }
        else if (this.state.orgCode && this.state.orgCode.length > 0 && /[\/'%\^$!?><&;]/.test(this.state.orgCode)) {
            error = "Organization Code can not contain special Characters (/'%^$!?><&;)";
            this.props.setError(error);
        }
      
        if (error.length === 0) {
            error = ''
            let body = {
                "firstName": this.state.firstName,
                "lastName": this.state.lastName,
                "email": this.state.email,
                "organizationName": this.state.organizationName,
                "noOfUsers" : this.state.noOfUsers,
                "orgCode" : this.state.orgCode?.trim()
            }
            this.props.createCustomer(body)
        }
    }

    render() {
        return (
            <div className={'px-5 mt-4'}>
                <div className={`${Style.headerBg} px-5 d-flex align-items-center justify-content-between`}>
                    <div onClick={this.handleClick} style={{ cursor: 'pointer' }}>
                        <img style={{ height: '1.5vw' }} src={BackIcon} alt={'back-icon'} />
                        Return to Organization Management
                    </div>
                </div>
                <div className={`${Style.detailsContainer} w-50 mt-4 py-5 px-5`}>
                    <div className={`d-flex flex-column`}>
                        <input name='organizationName' placeholder={'Organization Name*'} className={`${Style.inputStyle} focus-none`} onChange={this.handleChange} />

                        <input name='email' placeholder={'Primary Admin Email'} className={`${Style.inputStyle} focus-none mt-3`} onChange={this.handleChange} />

                        <input name='firstName' placeholder={'First Name'} className={`${Style.inputStyle} focus-none mt-3`} onChange={this.handleChange} />

                        <input name='lastName' placeholder={'Last Name'} className={`${Style.inputStyle} focus-none mt-3`} onChange={this.handleChange} />

                        <input name='orgCode' placeholder={'Organization Code (optional)'} className={`${Style.inputStyle} focus-none mt-3`} onChange={this.handleChange} />
                        <div class={`${Style.note}`}>Organisation Code cannot contain {"(/'%^$!?><&;)"}.</div>

                        <input type='number' name='noOfUsers' placeholder={'No. of Users*'} InputProps={{ inputProps: { min: 1 } }} className={`${Style.inputStyle} focus-none mt-3`} onChange={this.handleChange} />
                    </div>
                    <div className={'mt-4'}>
                        <button onClick={this.handleSubmit} className={`${Style.submitButton} px-4 focus-none`}>Add Organization</button>
                        <button onClick={this.handleClick} className={`${Style.cancelButton} px-4 ml-2 focus-none`}>Cancel</button>
                    </div>
                </div>
                {this.props.statusCode && <ModalPopup handleClick={this.handleClick} statusCode={this.props.statusCode} msg={this.props.userMsg}/> }
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    customerFlag: state.entities.customers.createCustomerFlag,
    userToken: state.entities.user.token,
    refreshToken: state.entities.user.refreshToken,
    userMsg: state.entities.customers.userMsg,
    statusCode: state.entities.customers.statusCode,
})

const mapDispatchToProps = (dispatch) => ({
    createCustomer: (body) => dispatch(createCustomer(body)),
    setNewToken: () => dispatch(setNewToken()),
    setError: (error) => dispatch(setError(error))
})

export default connect(mapStateToProps, mapDispatchToProps)(AddOrganization)